export default {
      id: "bread-usage",
      viewBox: "0 0 30 26",
      url: __webpack_public_path__ + "img/icons.svg#bread",
      toString: function () {
        return this.url;
      }
    }